import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=ef0c197a&scoped=true&lang=pug"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=ef0c197a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0c197a",
  null
  
)

export default component.exports